import React, { MutableRefObject } from 'react'
import { Field, Form as FinalForm } from 'react-final-form'
import { Link, useHistory } from 'react-router-dom'
import { Button, Form, Segment } from 'semantic-ui-react'
import {
  PATH_PRODUCTS_EDIT,
  PATH_PRODUCTS_NEW,
  SWITCH_TO_CREATE,
  SWITCH_TO_EDIT,
} from '../../consts'
import { ProductNoticeModal } from './ProductNoticeModal'

export const LookupBar = ({
  loading,
  productFormPristine,
  productId,
  edit,
  showCreateNoticeButton,
}: {
  loading: boolean
  productFormPristine: MutableRefObject<boolean>
  productId?: number
  edit?: boolean
  showCreateNoticeButton?: boolean
}) => {
  const initialValues = { product_id: productId }
  const history = useHistory()

  const warnUnsavedChanges = (): boolean => {
    if (productFormPristine.current) return true
    return window.confirm('Any unsaved changes will be lost. Would you like to proceed?')
  }

  const onSubmit = ({ product_id }: { product_id: number }) => {
    const path = edit ? `${PATH_PRODUCTS_NEW}/${product_id}` : `${PATH_PRODUCTS_EDIT}/${product_id}`

    warnUnsavedChanges() && history.push(path)
  }

  const clear = () => {
    const path = edit ? PATH_PRODUCTS_NEW : PATH_PRODUCTS_EDIT

    warnUnsavedChanges() && history.push(path)
  }

  return (
    <Segment basic padded style={{ margin: 0 }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          flexFlow: 'row wrap',
        }}
      >
        <div>
          <FinalForm onSubmit={onSubmit} initialValues={initialValues}>
            {({ handleSubmit, submitting }) => (
              <Form onSubmit={handleSubmit} style={{ display: 'inline-block' }}>
                <div
                  style={{
                    display: 'flex',
                    gap: '10px',
                    alignItems: 'flex-start',
                  }}
                >
                  <Field name="product_id" type="number">
                    {(props) => (
                      <Form.Input {...props.input} placeholder="Quick id lookup" min="1" required />
                    )}
                  </Field>
                  <Button type="submit" loading={loading} disabled={submitting}>
                    Lookup
                  </Button>
                  <Button
                    basic
                    type="button"
                    circular
                    icon="close"
                    onClick={clear}
                    disabled={submitting}
                  />
                </div>
              </Form>
            )}
          </FinalForm>
        </div>
        <div>
          {edit ? (
            <Link
              to={
                productId
                  ? `${PATH_PRODUCTS_EDIT}/${productId}${history.location.search}`
                  : PATH_PRODUCTS_EDIT
              }
              className="ui button secondary"
              style={{ flexBasis: 'content' }}
            >
              {SWITCH_TO_EDIT}
            </Link>
          ) : (
            <>
              {showCreateNoticeButton && <ProductNoticeModal productId={productId} />}
              <Link
                to={
                  productId
                    ? `${PATH_PRODUCTS_NEW}/${productId}${history.location.search}`
                    : PATH_PRODUCTS_NEW
                }
                className="ui button secondary"
                style={{ flexBasis: 'content' }}
              >
                {SWITCH_TO_CREATE}
              </Link>
            </>
          )}
        </div>
      </div>
    </Segment>
  )
}
